import React from 'react';
import PropTypes from 'prop-types';
import GoogleMapStaticImage from 'components/maps/GoogleMapStaticImage';
import MapWithMarkerButton from 'pages/Property/MapWithMarkerButton';

const PropertyMapStatic = ({ latitude, longitude, locationName, width, height }) => {
  const location = `${latitude},${longitude}`;

  return (
    <MapWithMarkerButton latitude={latitude} longitude={longitude} locationName={locationName}>
      <GoogleMapStaticImage location={location} locationName={locationName} width={width} height={height} markers />
    </MapWithMarkerButton>
  );
};

PropertyMapStatic.propTypes = {
  latitude: PropTypes.number.isRequired,
  longitude: PropTypes.number.isRequired,
  locationName: PropTypes.string.isRequired,
  width: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.array, PropTypes.number]),
};

PropertyMapStatic.defaultProps = {
  width: 400,
  height: 216,
};

export default PropertyMapStatic;
